var filterFooterTexts = {
  'sv-SE': {
    clearFilters: 'Töm filter',
    showTrip: 'Visa min resa'
  },
  'nb-NO': {
    clearFilters: 'Tøm filter',
    showTrip: 'Vis turen min'
  },
  'da-DK': {
    clearFilters: 'Ryd filter',
    showTrip: 'Vise min tur'
  },
  'fi-FI': {
    clearFilters: 'Tyhjennä suodatin',
    showTrip: 'Näytä matkani'
  },
  en: {
    clearFilters: 'Clear filter',
    showTrip: 'Show my trip'
  }
};
var texts = filterFooterTexts;

export { texts as default };
//# sourceMappingURL=FilterFooter.texts.js.map
